export default {
    designer: false,
    live: false,
    legacyRenderer: true,
    readOnly: false,
    qfDebug: false,
    pageReference: null,
    defaultGenerics: { display: true, readOnly: false, mandatory: false },
    defaultColors: [
        { label: "primary", value: "primary", theme: true },
        { label: "secondary", value: "secondary", theme: true },
        { label: "tertiary", value: "tertiary", theme: true },
        { label: "accent", value: "accent", theme: true },
        { label: "positive", value: "positive", theme: true },
        { label: "negative", value: "negative", theme: true },
        { label: "info", value: "info", theme: true },
        { label: "warning", value: "warning", theme: true },
        { label: "light", value: "light", theme: true },
        { label: "faded", value: "faded", theme: true },
        { label: "dark", value: "dark", theme: true },
        { label: "black", value: "black", theme: false },
        { label: "white", value: "white", theme: false },
        { label: "red", value: "red", theme: false },
        { label: "pink", value: "pink", theme: false },
        { label: "purple", value: "purple", theme: false },
        { label: "deep-purple", value: "deep-purple", theme: false },
        { label: "indigo", value: "indigo", theme: false },
        { label: "blue", value: "blue", theme: false },
        { label: "light-blue", value: "light-blue", theme: false },
        { label: "cyan", value: "cyan", theme: false },
        { label: "teal", value: "teal", theme: false },
        { label: "green", value: "green", theme: false },
        { label: "light-green", value: "light-green", theme: false },
        { label: "lime", value: "lime", theme: false },
        { label: "yellow", value: "yellow", theme: false },
        { label: "amber", value: "amber", theme: false },
        { label: "orange", value: "orange", theme: false },
        { label: "deep-orange", value: "deep-orange", theme: false },
        { label: "brown", value: "brown", theme: false },
        { label: "grey", value: "grey", theme: false },
        { label: "blue-grey", value: "blue-grey", theme: false }
    ],
    colorValue: {
        primary: { value: "#3E71D2", default: "#3E71D2", theme: true },
        secondary: { value: "#26A69A", default: "#26A69A", theme: true },
        tertiary: { value: "#212121", default: "#212121", theme: true },
        accent: { value: "#FFFFFF", default: "#FFFFFF", theme: true },
        positive: { value: "#21BA45", default: "#21BA45", theme: true },
        negative: { value: "#DB2828", default: "#DB2828", theme: true },
        info: { value: "#31CCEC", default: "#31CCEC", theme: true },
        warning: { value: "#F2C037", default: "#F2C037", theme: true },
        light: { value: "#BDBDBD", default: "#BDBDBD", theme: true },
        faded: { value: "#777", default: "#777", theme: true },
        dark: { value: "#424242", default: "#424242", theme: true },
        black: { value: "#000000" },
        white: { value: "#FFFFFF" },
        red: { value: "#F44336" },
        pink: { value: "#E91E63" },
        purple: { value: "#9C27B0" },
        "deep-purple": { value: "#673AB7" },
        indigo: { value: "#3F51B5" },
        blue: { value: "#2196F3" },
        "light-blue": { value: "#03A9F4" },
        cyan: { value: "#00BCD4" },
        teal: { value: "#009688" },
        green: { value: "#4CAF50" },
        "light-green": { value: "#8BC34A" },
        lime: { value: "#CDDC39" },
        yellow: { value: "#FFEB3B" },
        amber: { value: "#FFC107" },
        orange: { value: "#FF9800" },
        "deep-orange": { value: "#FF5722" },
        brown: { value: "#795548" },
        grey: { value: "#9E9E9E" },
        "blue-grey": { value: "#607D8B" }
    },
    aiActions: [],

    // == sidebar =======
    sidebarComponents: {
        basic: {
            layout: [],
            standard: [],
            form: [],
            custom: []
        }
    },
    sidebarLoading: {
        basic: true
    },
    loadingInterfaces: true,

    // designer components
    saveErrors: false,
    components: {},
    componentsPropertiesCategories: {},
    richTextCache: {},
    activeComponent: null,
    containers: [],
    automatedIndex: {},
    indexPairs: {},

    // Data model
    latestVersion: null,
    raw: {},
    parsed: {
        firstTime: true,
        apis: {}
    }, // { catalogs, modelClasses, apis, variables }

    // Interfaces
    currentInterfaceProperties: null,
    appInterfaces: [],
    activeInterface: null,
    interfaceModel: {},
    currentInterfaceModel: null,
    assistantVisibility: true,
    assistantForceOpen: false,
    emptyInterface: {
        id: null,
        code: null,
        name: null,
        type: "GUI",
        description: null,
        processImage: null
    },

    // interface variables
    routeEnter: false,
    bodyReference: {
        body: []
    },
    element: {},
    properties: {},
    fileNameWithDataModel: null,
    filenameChange: null,
    data: {},
    slots: {},
    legacyElementState: {},
    elementState: {},
    fragments: {},
    resetId: [],
    goToPath: null,

    // properties collapse history
    collapseHistory: {},

    // keep all issues here
    issues: [],
    errorsClicked: [],

    // functional interface
    goToComponent: "",
    selectPath: [],
    futureValues: {},
    processInstanceId: null,
    activityId: null,
    taskId: null,
    isSmallScreen: false,
    workInProgress: false,
    submitActionsList: [],
    filteredOutcomes: [],

    // events
    catalogData: {},
    guidToCode: {},
    codeToGuid: {},
    events: {},
    currentAddedComponent: null
};
